import React from "react";

import { useDemographics } from "~/sdks/LocalDemographics/context";

import { HomeOwnershipType } from "./HomeOwnershipType";
import { TypeOfHousing } from "./TypeOfHousing";

import * as styles from "../styles";

export const Housing = () => {
  const {
    demographicsState: {
      property_tenure: propertyTenure,
      housing_tenancy: housingTenancy,
      housing_type: housingType,
    },
  } = useDemographics();

  // For the US, the name of the property changes
  const housingInfo = housingTenancy || propertyTenure;

  return (
    <div className={styles.graphLayoutWrapper}>
      {housingInfo && (
        <div className={styles.graphSideBySide}>
          <div className={styles.graphContainer} data-size={"half"}>
            <HomeOwnershipType />
          </div>
        </div>
      )}
      {housingType && (
        <div className={styles.graphContainer} data-size={"half"}>
          <TypeOfHousing />
        </div>
      )}
    </div>
  );
};
